module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtit"
  }, [_vm._v("List of Maps")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maps by Edward Alexander")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Fm02#map1"
    }
  }, [_vm._v("Northside Driving Tour")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Fm02#map2"
    }
  }, [_vm._v("Southside Driving Tour")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Fm02#map3"
    }
  }, [_vm._v("Downtown Walking Tour")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#map4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charleston Harbor")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#map5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battle of Sullivan’s Island")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#map6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prevost’s Invasion")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#map7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prevost’s Withdrawal")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#map8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battle of Stono Ferry")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#map9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battle of Savannah")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter05#map10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clinton’s Invasion")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter06#map11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Siege of Charleston")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Footnotes for the volume are available at")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://emergingrevolutionarywar.org/emerging-revolutionary-war-series/to-the-last-extremity-footnotes/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://emergingrevolutionarywar.org/emerging-revolutionary-war-series/to-the-last-extremity-footnotes/")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80bb6434","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_List.vue
// module id = 75
// module chunks = 0